import React from 'react';
import { Slider, Row, Col, Form, Select, InputNumber, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { ROLE_MARKETING_MANAGER } from '../../../constants/roles';

const { Option } = Select;

const FurtherCriteriaDetails = (props) => {
  const { initialValues, onMove, onSubmitPayload } = props;
  const [form] = Form.useForm();

  const onFinish = (values) => {
    onSubmitPayload(2, values);
  };
  const role = useSelector((state) => get(state, 'auth.role'));
  const isMarketingManager = get(role, 'role_code') === ROLE_MARKETING_MANAGER;

  return (
    <Form
      name="basic"
      layout="vertical"
      form={form}
      initialValues={
        initialValues || {
          item_per_user: isMarketingManager ? 1 : '',
          age: [15, 30],
        }
      }
      onFinish={onFinish}
      autoComplete="off"
      requiredMark
    >
      <Row gutter={32} className="mt-60">
        <Col xl={16}>
          <Form.Item name="age" label="Age">
            <Slider
              range
              tooltip={{ open: true }}
              max={100}
              defaultValue={[15, 30]}
              marks={{
                0: '0',
                50: '50',
                100: '100',
              }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={32} className="mt-30">
        <Col xl={8}>
          <Form.Item
            label="Gender"
            name="gender"
            className="form-item"
            rules={[
              {
                required: true,
                message: 'Please select Gender!',
              },
            ]}
          >
            {/* ///M, F, A */}
            <Select size="large" placeholder="Select gender">
              <Option value="M" key="">
                Male
              </Option>
              <Option value="F" key="">
                Female
              </Option>
              <Option value="A" key="">
                Both
              </Option>
            </Select>
          </Form.Item>
        </Col>
        <Col xl={8}>
          <Form.Item
            label="Item Per User can avail"
            name="item_per_user"
            className="form-item"
            rules={[
              {
                required: true,
                message: 'Please input item count!',
              },
            ]}
          >
            <InputNumber
              style={{ width: '100%' }}
              size="large"
              placeholder="No. of items"
              disabled={isMarketingManager}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row justify="space-evenly" className="mt-60">
        <Col xl={8}>
          <Button
            className="default-primary-btn"
            type="primary"
            onClick={() => onMove(1)}
            icon={<ArrowLeftOutlined />}
          >
            Back
          </Button>
        </Col>
        <Col xl={12} />
        <Col xl={4}>
          <Button
            htmlType="submit"
            className="default-primary-btn"
            type="primary"
            block
          >
            Save & Proceed
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default FurtherCriteriaDetails;
